import type { PagedCourseDraftsPageableSort } from './pagedCourseDraftsPageableSort';

/**
 * 페이징 정보
 */
export type PagedCourseDraftsPageable = {
  /** 오프셋 */
  offset?: number;
  /** 페이징 여부 */
  paged?: boolean;
  /** 페이지 번호 */
  pageNumber?: number;
  /** 페이지 크기 */
  pageSize?: number;
  /** 정렬 정보 */
  sort?: PagedCourseDraftsPageableSort;
  /** 페이징 안 함 여부 */
  unpaged?: boolean;
};
